import { v4 } from 'uuid';

const BASE58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

function encodeBase58(uuid: string): string {
  let b = BigInt('0x' + uuid.replace(/[^a-f0-9]/gi, ''));
  let u58 = '';
  do {
    const index = parseInt((b % BigInt(BASE58_ALPHABET.length)).toString(), 10);
    u58 = BASE58_ALPHABET[index] + u58;
    b = b / BigInt(BASE58_ALPHABET.length);
  } while (b > 0);
  return u58;
}

export default function generateRandomBlockId() {
  return `block_${encodeBase58(v4())}`;
}
